export const profile = {
  name: "Airton Domiciano",
  intro: {
    greeting: "Ola, eu sou",
    role: "Desenvolvedor Full-Stack",
    blurb:
      "Desenvolvo e evoluo produtos digitais completos, conectando tecnologia, UX e estrategia para entregar resultados consistentes e escalaveis",
    itemsIntro: [
      "+7 anos construindo produtos web com foco em resultado.",
      "Integro front e back-end garantindo performance e manutencao.",
    ],
    imageAlt: "Airton no espaco",
    buttonsLabel: "Perfis profissionais",
  },
  btnGithub: "Ver GitHub",
  btnDownloadCV: "Baixar CV",
  btnLinkedIn: "Conectar no LinkedIn",
  about: {
    title: "Sobre Mim",
    md: "sobre-mim.md",
    type: "sobre",
    terminal: {
      user: "airton@portfolio",
      command: "cat sobre-mim.md",
    },
    imageAlt: "Sobre: visual estatico",
    description:
      "Sou um desenvolvedor full-stack movido por desafios e pela busca constante de evolucao. Tenho foco em criar sistemas robustos, escalaveis e faceis de manter, sempre priorizando organizacao, qualidade e resultado. Acredito que um bom codigo vai alem da entrega tecnica - ele traduz clareza, proposito e impacto para o negocio. Valorizo colaboracao, aprendizado continuo e boas praticas, contribuindo para times que buscam excelencia e melhoria constante.",
    focusAreas: [
      {
        label: "Stack",
        value: "Angular / React / NestJS / GraphQL / TypeORM / Node.js / Docker",
      },
      {
        label: "Especialidade",
        value:
          "Desenvolvimento de ERPs modulares, automacoes e integracoes escalaveis",
      },
      {
        label: "Rotina",
        value:
          "Revisoes de codigo, testes, metricas e colaboracao em squads ageis (Scrum/Kanban)",
      },
    ],
    badge: {
      icon: "*",
      label: "Trajetoria em foco",
    },
    tags: ["Mentoria & lideranca tecnica", "Aberto a oportunidades globais"],
    highlights: [
      "Transformo ideias em solucoes rapidas, seguras e faceis de manter.",
      "Defino padroes e reviso codigos para garantir qualidade em cada entrega.",
      "Coordeno equipes com foco em produtividade e boa comunicacao.",
      "Ajudo novos desenvolvedores a crescer e busco sempre evoluir com novos desafios.",
    ],
  },
};
